import React, { useCallback } from "react";
import { Checkbox } from "components/Inputs";
import { useGetFileNameOrTitle } from "hooks";
import { toggleCheckboxState } from "utils";
import type { CheckboxItem } from "interfaces/product/product.types";
import type { Dispatch, SetStateAction } from "react";

type Props = {
  title: string;
  itemsData: CheckboxItem[];
  checked?: boolean;
  setItemsData: Dispatch<SetStateAction<CheckboxItem[]>>;
  toggle: (id: string) => void;
  id: string;
  expandedAccordionIds: string[];
};

export const CheckboxAccordionContent = ({
  title,
  itemsData,
  checked = false,
  setItemsData,
  toggle,
  id,
  expandedAccordionIds,
}: Props) => {
  const getFileNameOrTitle = useGetFileNameOrTitle();
  const handleCheckboxClick = useCallback(
    (documentId: string): void => {
      setItemsData((prevData) => toggleCheckboxState(prevData, documentId));

      if (!expandedAccordionIds.includes(documentId)) {
        toggle(documentId);
      }
    },
    [setItemsData, expandedAccordionIds, toggle],
  );

  const displayedTitle = getFileNameOrTitle(title, itemsData);

  return (
    <div
      className="d-flex align-items-center"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Checkbox
        id={id}
        checked={checked}
        data-testid={`checkbox-on-${title}`}
        onChange={() => handleCheckboxClick(id)}
      />
      <label
        htmlFor={id}
        className="ms-2 text-gray-700 "
        onClick={() => handleCheckboxClick(id)}
      >
        {displayedTitle}
      </label>
    </div>
  );
};
